import { faArrowLeftLong, faArrowRightLong } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useRef, useState } from "react";
import Carousel from "react-multi-carousel";
import Testimonials from "./PackagingTestimonials";
import { Container } from "react-bootstrap";
import PackagingTestimonials from "./PackagingTestimonials";
import * as fldExtract from "../../src/Helpers/FieldExtractors";
import { Testimonialsresponsive } from "../Helpers/Responsive";

function PackagingComponent(props) {

    const carouselRef: any = useRef(null);
    var sortedPackaging = props.data; 
    const [currentSlide, setCurrentSlide] = useState(0);



    const handleNextCard = () => {
        carouselRef.current.state.currentSlide = carouselRef.current.state.currentSlide + 1;
        if (((carouselRef.current.state.currentSlide) + (carouselRef.current.state.slidesToShow)) > carouselRef.current.state.totalItems) {
            carouselRef.current.state.currentSlide =  carouselRef.current.state.currentSlide -1 ;
            return;
        }
        const nextSlide = carouselRef.current.state.currentSlide;
        setCurrentSlide(nextSlide);
        carouselRef.current.goToSlide(nextSlide);   
       
    };

   

    const handlePrevCard = () => {
        if (carouselRef.current.state.currentSlide == 0){
            return;
        }
        const prevSlide = carouselRef.current.state.currentSlide - 1;
      
        setCurrentSlide(prevSlide);
        carouselRef.current.goToSlide(prevSlide);
    };

    const handleNextCardMobile = () => {
        carouselRef.current.state.currentSlide = carouselRef.current.state.currentSlide + 1;
        if (((carouselRef.current.state.currentSlide) + (carouselRef.current.state.slidesToShow)) == carouselRef.current.state.totalItems) {
            carouselRef.current.state.currentSlide = carouselRef.current.state.currentSlide - 1;
            return;
        }
        const nextSlide = carouselRef.current.state.currentSlide;
        carouselRef.current.goToSlide(nextSlide)
       
       
    };

    const  handlePrevCardMobile = () => {
        if((carouselRef.current.state.currentSlide) < 1){
            return;
        }

        const prevSlide  = carouselRef.current.state.currentSlide - 1;
        carouselRef.current.goToSlide(prevSlide);
    }




    return (
        <Container>
            <div className="row ">
                <div className='col-lg-4 col-12 col-xl-3 ' >
                    <h2 className='fw-bold mb-4'>{props.Heading}</h2>
                    <div className="d-none d-lg-flex">
                        <FontAwesomeIcon icon={faArrowLeftLong} className='pe-3 fa-2xl' style={{ cursor: ' pointer' }} onClick={handlePrevCard} /> &nbsp; &nbsp;
                        <FontAwesomeIcon icon={faArrowRightLong} className=' fa-2xl' style={{ cursor: ' pointer' }} onClick={handleNextCard} />
                    </div>
                </div>

                <div className='col-lg-8 col-12 col-xl-9 ps-lg-0'>
                    <Carousel
                        responsive={Testimonialsresponsive}
                        ssr={true}
                        ref={carouselRef}
                        arrows={false}
                        draggable={true}
                        swipeable={false}               
                    >
                        {sortedPackaging != null && sortedPackaging.length > 0 && sortedPackaging.map((items, index) => (
                            <div key={index} className=' pe-2 mb-2 '>
                                <PackagingTestimonials items={items} />
                            </div>
                        ))}
                    </Carousel>
                </div>

                <div className="col-12 mt-4 ps-4 d-lg-none ">               
                        <FontAwesomeIcon icon={faArrowLeftLong} className='pe-3 fa-2xl' style={{ cursor: ' pointer' }} onClick={handlePrevCardMobile} /> &nbsp;
                        <FontAwesomeIcon icon={faArrowRightLong} className=' fa-2xl' style={{ cursor: ' pointer' }} onClick={handleNextCardMobile} />               
                </div>
            </div>
        </Container>
    )
}

export default PackagingComponent;
